export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "az", label: "Azərbaycan dili" },
];

const DICT = {
  en: {
    "nav.overview": "Overview",
    "nav.channels": "Channels & Profiles",
    "nav.command": "AI Command Center",
    "nav.research": "Research & Ideas",
    "nav.pipeline": "Content Pipeline",
    "nav.autopilot": "Autopilot",
    "nav.styles": "Styles",
    "nav.studio": "Production Studio",
    "nav.review": "Review & Approvals",
    "nav.calendar": "Publishing Calendar",
    "nav.analytics": "Analytics & Costs",
    "nav.earnings": "Earnings",
    "nav.team": "AI Team",
    "nav.mcp": "MCP Connections",
    "nav.integrations": "Integrations",
    "nav.settings": "Settings",
    "top.search": "Search channels…",
    "top.newVideo": "New video",
    "top.newVideoHint": "Available once production launches (Phase 2)",
    "top.notifications": "Notifications",
    "top.logout": "Log out",
    "section.foundation": "Foundation",
    "section.production": "Production",
    "section.workspace": "Workspace",
  },
  az: {
    "nav.overview": "İcmal",
    "nav.channels": "Kanallar və Profillər",
    "nav.command": "Süni İntellekt İdarə Mərkəzi",
    "nav.research": "Araşdırma və İdeyalar",
    "nav.pipeline": "Kontent Konveyeri",
    "nav.autopilot": "Avtopilot",
    "nav.styles": "Stillər",
    "nav.studio": "İstehsalat Studiyası",
    "nav.review": "Baxış və Təsdiqlər",
    "nav.calendar": "Dərc Təqvimi",
    "nav.analytics": "Analitika və Xərclər",
    "nav.earnings": "Gəlirlər",
    "nav.team": "Süni İntellekt Komandası",
    "nav.mcp": "MCP Bağlantıları",
    "nav.integrations": "İnteqrasiyalar",
    "nav.settings": "Tənzimləmələr",
    "top.search": "Kanalları axtar…",
    "top.newVideo": "Yeni video",
    "top.newVideoHint": "İstehsalat başlayanda əlçatan olacaq (Faza 2)",
    "top.notifications": "Bildirişlər",
    "top.logout": "Çıxış",
    "section.foundation": "Əsas",
    "section.production": "İstehsalat",
    "section.workspace": "İş sahəsi",
  },
};

export function makeT(lang) {
  const table = DICT[lang] || DICT.en;
  return (key) => table[key] || DICT.en[key] || key;
}
